module.exports = __webpack_public_path__ + "static/media/montotox.4257883a.jpg";